import { DraggableContainer } from '../../../../components/DraggableContainer';
import { Route } from '../../../../domain/route/Route';
import { Stop } from '../../../../domain/stops/Stop';
import { useRouteContext } from '../context/context';
import { RouteStopsContainerHeader } from './route-stops-container-header/RouteStopsContainerHeader';
import { useSetSelectedStop } from './stop/hooks/useSetSelectedStop';
import { StopsListContainer } from './StopsListContainer';

type RouteStopsContainerProps = {
  footerSize?: number;
  selectedRoute: Route;
  onSelectStop: (stop: Stop) => void;
  onEndRoute: () => void;
  openSearch: () => void;
};

export const RouteStopsContainer = ({
  footerSize = 0,
  selectedRoute,
  onSelectStop,
  onEndRoute,
  openSearch,
}: RouteStopsContainerProps) => {
  // We Unset the selected stop when no stop is selected
  useSetSelectedStop();
  const { nextStopTopScroll: topScroll } = useRouteContext().routeState;

  return (
    <DraggableContainer
      sizeOfFooter={footerSize}
      sizeOfTopButtons={80}
      respectFooter={false}
      initScroll={topScroll}
      drags={[
        <RouteStopsContainerHeader onEndRoute={onEndRoute} selectedRoute={selectedRoute} openSearch={openSearch} />,
      ]}
      details={[
        <StopsListContainer
          route={selectedRoute}
          openSearch={openSearch}
          onSelectStop={(stopId: string) => {
            const stop = selectedRoute.getStopById(stopId);
            if (stop) onSelectStop(stop);
          }}
        />,
      ]}
    />
  );
};
